import { useInstance } from 'intact-vue';
import { useState } from '../../hooks/useState';
import { useReceive } from '../../hooks/useReceive';
export function useSize() {
  var instance = useInstance();
  var firstSize = useState('auto');
  var lastSize = useState('auto');
  fixSize();
  useReceive(['firstSize', 'lastSize'], fixSize, true);
  function fixSize() {
    var _instance$get = instance.get(),
      first = _instance$get.firstSize,
      last = _instance$get.lastSize;
    if (first === 'auto' && last === 'auto') {
      firstSize.set('50%');
      lastSize.set(last);
    } else if (first !== 'auto' && last !== 'auto') {
      firstSize.set(first);
      lastSize.set('auto');
    } else {
      firstSize.set(first);
      lastSize.set(last);
    }
  }
  ;
  return {
    firstSize: firstSize,
    lastSize: lastSize
  };
}